import { render, staticRenderFns } from "./SingleCrochetIcon.vue?vue&type=template&id=88257938&scoped=true"
import script from "./SingleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./SingleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./SingleCrochetIcon.vue?vue&type=style&index=0&id=88257938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88257938",
  null
  
)

export default component.exports